import { useContext } from 'react'
import { RequestUserConfigContext } from '../context/request-user-config'

export const useRequestUserConfigContext = () => useContext(RequestUserConfigContext)
